export default [
  {
    path: '/',
    redirect: '/document/0'
  },
  {
    path: '/error/:type',
    name: 'Error',
    component: 'Error' // 注意提供ErrorPage组件内的多语言翻译
  },
  {
    name: 'document',
    path: '/document/:id',
    menuCode: '001',
    component: 'document'
  },
  {
    name: 'download',
    path: '/download',
    menuCode: '002',
    component: 'download'
  },
  {
    name: 'abilityInfo',
    path: '/abilityInfo',
    menuCode: '003',
    component: 'abilityInfo'
  },
  {
    name: 'abilityDetail',
    path: '/abilityDetail',
    menuCode: '004',
    component: 'abilityDetail'
  }
]
